import { useAuthStore } from "@/lib/auth/AuthStore";
import { PassCategory } from "../../../api/membership";
// 타입 가드 함수: GetOrderResponse인지 확인
export const isGetOrderResponse = (data)=>{
    return "items" in data && "userCoupons" in data && "total" in data;
};
// 타입 가드 함수: UseTicketProductInfo인지 확인
export const isUseTicketProductInfo = (data)=>{
    return "deductionMethod" in data && "subjectCode" in data && "category" in data;
};
// 타입 가드 함수: GetPackageResponse인지 확인
export const isGetCashItemResponse = (data)=>{
    return "products" in data && Array.isArray(data.products) && data.products.length > 0 && "title" in data.products[0];
};
// OrderInfo 추출 훅
// @TODO pod일 경우 orderName을 title이 아닌 orderTitle로 반환해야함
export const useOrderInfo = (paymentData)=>{
    const { user  } = useAuthStore();
    const getOrderInfo = ()=>{
        if (!paymentData) return null;
        const cashItemTitle = isGetCashItemResponse(paymentData) ? paymentData.products[0].title : "";
        if (isGetOrderResponse(paymentData)) {
            return {
                orderName: paymentData.title,
                customerEmail: paymentData.email,
                customerName: paymentData.name,
                customerMobilePhone: paymentData.phone
            };
        }
        if ("lineItems" in paymentData) {
            const titles = paymentData.lineItems.map((item)=>item.product.title);
            const orderName = titles.length === 1 ? titles[0] : "".concat(titles[0], " 외 ").concat(titles.length - 1, "건");
            return {
                orderName,
                customerEmail: (user === null || user === void 0 ? void 0 : user.email) || "",
                customerName: (user === null || user === void 0 ? void 0 : user.displayName) || "",
                customerMobilePhone: (user === null || user === void 0 ? void 0 : user.phoneNumber) || ""
            };
        }
        // 다른 타입의 경우 기본값 반환
        return {
            orderName: cashItemTitle || "주문",
            customerEmail: (user === null || user === void 0 ? void 0 : user.email) || "",
            customerName: (user === null || user === void 0 ? void 0 : user.displayName) || "",
            customerMobilePhone: (user === null || user === void 0 ? void 0 : user.phoneNumber) || ""
        };
    };
    return getOrderInfo();
};
// Pass Amount Type 확인 훅 (orderType과 paymentData를 함께 받음)
export const usePassAmountType = (paymentData, orderType)=>{
    // pass 타입일 때만 deductionMethod 확인
    if (orderType === "pass" && paymentData && isUseTicketProductInfo(paymentData)) {
        return paymentData.deductionMethod === "amount";
    }
    return false;
};
// Toss Payments 파라미터 처리 함수들
export const parseTossSuccessParams = (query)=>{
    if (!query.paymentKey || !query.orderId || !query.amount) {
        return null;
    }
    return {
        paymentKey: query.paymentKey,
        orderId: query.orderId,
        amount: Number(query.amount),
        paymentType: query.paymentType
    };
};
export const parseTossFailParams = (query)=>{
    if (!query.code || !query.message || !query.orderId) {
        return null;
    }
    return {
        code: query.code,
        message: query.message,
        orderId: query.orderId
    };
};
// 월구독 빌링 등록 파라미터 처리 함수들
// 일회용 결제 파서와 달리 billingResult로 판별한다. 빌링 실패에는 orderId가 없어
// parseTossFailParams(code·message·orderId 요구)에 걸리지 않으므로 서로 충돌하지 않는다.
export const parseBillingSuccessParams = (query)=>{
    if (query.billingResult !== "success" || !query.authKey || !query.customerKey) {
        return null;
    }
    return {
        authKey: query.authKey,
        customerKey: query.customerKey
    };
};
export const parseBillingFailParams = (query)=>{
    if (query.billingResult !== "fail") {
        return null;
    }
    var _query_code, _query_message;
    return {
        code: (_query_code = query.code) !== null && _query_code !== void 0 ? _query_code : "UNKNOWN",
        message: (_query_message = query.message) !== null && _query_message !== void 0 ? _query_message : "알 수 없는 오류가 발생했어요."
    };
};
// 주문 타입을 숫자로 변환하는 함수
export const getOrderTypeNumber = (orderType)=>{
    const orderTypeMap = {
        separate: 0,
        ticket: 4,
        expert: 6,
        package: 8,
        freepass: 9,
        pod: 10,
        ebook: 2,
        delivery: 11,
        cash: 12,
        upgrade: 13
    };
    var _orderTypeMap_orderType;
    return (_orderTypeMap_orderType = orderTypeMap[orderType]) !== null && _orderTypeMap_orderType !== void 0 ? _orderTypeMap_orderType : 0;
};
// pass 타입을 쉽게 처리하는 헬퍼 함수
const getPassOrderType = (passCategory)=>{
    if (!passCategory) return 0;
    // PassCategory enum 값들을 직접 매핑
    switch(passCategory){
        case PassCategory.Ticket:
            return 4;
        case PassCategory.Expert:
            return 6;
        case PassCategory.FreePass:
            return 9;
        case PassCategory.Solvookplus:
            return 1;
        case PassCategory.Subscription:
            return 5;
        case PassCategory.ExpertSubscription:
            return 7;
        default:
            return 0;
    }
};
// 주문 타입과 pass 카테고리를 모두 처리하는 통합 함수
export const getOrderTypeFromParams = (orderType, passCategory)=>{
    // pass 타입인 경우 passCategory를 우선 사용
    if (orderType === "pass" && passCategory) {
        return getPassOrderType(passCategory);
    }
    // 그 외의 경우 orderType을 사용
    return getOrderTypeNumber(orderType);
};
export const ORDER_TYPE_CATEGORIES = {
    0: "Single Product Order",
    1: "Solvook Plus",
    2: "ebook",
    3: "Aladin",
    4: "Ticket",
    5: "Solvook Plus Subscription",
    6: "Expert",
    7: "Expert Subscription",
    8: "Package",
    9: "FreePass",
    10: "POD",
    11: "Delivery",
    12: "Cash",
    13: "Upgrade"
};
export const getOrderTypeCategory = (orderType)=>{
    return ORDER_TYPE_CATEGORIES[orderType] || "기타";
};
